import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    display: "inline-block",
    position: "relative",
    fontSize: theme.typography.pxToRem(12),
    backgroundColor: "#E0E4EB",
    color: "#505050",
    borderRadius: "3px",
    padding: "4px 8px",
    whiteSpace: "pre-wrap",
  },
  arrow: {
    color: "#E0E4EB",
  },
}))(Tooltip);

// eslint-disable-next-line import/prefer-default-export
export const ToolTip = (props) => {
  const {
    title,
    placement,
    showArrow,
    component,
    className = "",
  } = props;
  if (title === "") {
    return component;
  }
  return (
    <HtmlTooltip
      placement={placement}
      arrow={showArrow !== false}
      title={<>{title}</>}
    >
      <div className={`toolTipWrapper ${className}`}>{component}</div>
    </HtmlTooltip>
  );
};
